import './Popup.less';
import { useEffect, useRef, useContext, useState } from 'react';
import close from '@/assets/edit/close.png';
import { EditContext } from '@/context/EditContext';
import { useDrawer } from '@/hooks/DrawerHooks';
import Credits from '@/assets/layouts/dashboard/Credits.png';
import Member from '@/assets/layouts/dashboard/member.png';
import { userService, infoController, projectController } from '@/api/index';
import { popupController } from '@/api/edit';
import { useTranslation } from 'react-i18next';
import { EseClosePopup } from '@/hooks/useClosePopup';
import message from '@/utils/message.jsx';
export default function EditPopUp(props) {
  return (
    <div className="edit_popup">
      {/* 重新翻译弹窗 */}
      <TranslatePop {...props} />
      {/* tts弹窗-原文 */}
      <TTSOriginalPop {...props} />
      {/* tts弹窗-译文 */}
      <TTSTranslationPop {...props} />
      {/*创建副本*/}
      <CreateCopyPop {...props} />
      {/*单句翻译*/}
      <SentenceTranslation {...props} />
    </div>
  );
}
function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
}
async function getUserInfo() {
  try {
    const res = await userService.userDetail();
    return res.data;
  } catch (error) {
    console.log(error);
  }
}
async function getPointConsume(sentenceNum = 1) {
  try {
    const res = await infoController.pointConsume();
    const sentencePoints = res.data.filter((res) => res.mode == 'sentence_modify')[0].number;
    const sentenceTranslation = res.data.filter((res) => res.mode == 'sentence_translation')[0]
      .number;
    return {
      translation: sentenceTranslation * sentenceNum,
      tts: sentencePoints * sentenceNum,
    };
  } catch (error) {
    console.log(error);
  }
}
function TranslatePop({ sentenceNum, targetLanguageCode, onTranslate }) {
  const { t } = useTranslation();
  // sentenceNum: 句子数量 targetLanguage：目标语言 onTranslate: 翻译回调
  const { translatePop, setTranslatePop, projectDetail, setProjectDetail, editTargetLanguageList } =
    useContext(EditContext);
  const { setIsOpen } = useDrawer();
  const [TTS, setTTS] = useState(true);
  const [targetLanguage, setTargetLanguage] = useState('');
  const [PriceInfo, setpriceInfo] = useState({});
  // 是否下次提醒状态
  // const [showTip, setShowTip] = useState(false)
  // 消耗积分
  const [consumePoints, setConsumePoints] = useState(0);
  // 用户积分
  const [userPoints, setUserPoints] = useState(0);
  const PopUpRef = useRef();
  // 转录状态
  const [translateState, setTranslateState] = useState(false);
  const [asLoading, setAsLoading] = useState(true);
  const init = async () => {
    const [have, consume] = await Promise.all([getUserInfo(), getPointConsume(sentenceNum)]);
    setUserPoints(have.actualTotalPoints);
    setpriceInfo({ translation: consume.translation, tts: consume.tts });
    const points1 = parseFloat((consume.translation + consume.tts).toFixed(1));
    const points2 = parseFloat(consume.translation.toFixed(1));
    setConsumePoints(TTS ? points1 : points2);
    setAsLoading(false);
  };
  useEffect(() => {
    if (translatePop) {
      init();
      const projectId = JSON.parse(sessionStorage.getItem('projectItem'))?.id || '';
      setTargetLanguage(
        editTargetLanguageList?.find((res) => res.id == targetLanguageCode)?.name ||
          JSON.parse(sessionStorage.getItem('targetLanguageInfo'))?.[projectId] ||
          '',
      );
      PopUpRef.current?.show();
    } else {
      setAsLoading(true);
      PopUpRef.current?.close();
    }
    setTTS(true);
  }, [translatePop]);
  useEffect(() => {
    if (TTS) {
      setConsumePoints(() => parseFloat((PriceInfo.translation + PriceInfo.tts).toFixed(1)));
    } else {
      setConsumePoints(() => parseFloat(PriceInfo.translation.toFixed(1)));
    }
  }, [TTS]);
  useEffect(() => {
    setTranslatePop(projectDetail.isTranslating);
    setTranslateState(projectDetail.isTranslating);
  }, [projectDetail.isTranslating]);
  // const handleCheckboxChangeSync = (e) => {
  //   setTTS(e.target.checked);
  // };
  // const handleSwitchChangeSync = (e) => {
  //   setShowTip(e.target.checked);
  // };
  const closePop = () => {
    setTranslatePop(false);
  };
  const upgrade = () => {
    window.onClickGATrackEvent('translate-upgrade');
    setIsOpen(true);
  };
  const useTranslate = () => {
    const projectId = JSON.parse(sessionStorage.getItem('projectItem'))?.id || '';
    const targetLanguageList = JSON.parse(sessionStorage.getItem('targetLanguageInfo')) || {};
    targetLanguageList[projectId] = targetLanguage;
    sessionStorage.setItem(`targetLanguageInfo`, JSON.stringify(targetLanguageList));

    setProjectDetail({ ...projectDetail, isTranslating: true });
    onTranslate(TTS);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      {!translateState && <EseClosePopup close={closePop} />}
      <div className="modal-box padding_model min-w-[480]">
        <div className="title translate_title">
          {t('As_Edit_GenerateSpeech')} {targetLanguage}
        </div>
        {!translateState && <img src={close} className="close" onClick={closePop} />}
        {/* <div className="content">
          <span>{t('As_Edit_GenerateSpeech')}</span>
          <input
            type="checkbox"
            className="toggle"
            checked={TTS}
            onChange={handleCheckboxChangeSync}
            disabled={translateState || asLoading}
          />
        </div> */}
        {asLoading || translateState ? (
          <div className="pop_bottom">
            <div className="tip"></div>
            <button className="btn btn-primary btn-xs submit" disabled>
              <span className="loading loading-spinner"></span>
              {t('As_Edit_Speechtranslation')}
            </button>
          </div>
        ) : userPoints >= consumePoints ? (
          <div className="pop_bottom">
            <div className="tip">
              {/* <input type="checkbox" className="checkbox checkbox-sm" checked={showTip} onChange={handleSwitchChangeSync} />Don’t show this anymore */}
            </div>
            <button className="btn btn-primary btn-xs submit" onClick={useTranslate}>
              <div>
                <span>{t('As_Edit_Speechtranslation')}</span>
                <div>
                  <img src={Credits} />
                  {consumePoints}
                </div>
              </div>
            </button>
          </div>
        ) : (
          <div className="pop_bottom">
            <div className="tip">
              {t('As_Edit_Creditstatusnotify')}: <img src={Credits} />
              {userPoints}
            </div>
            <button className="btn btn-primary btn-xs upgrade" onClick={upgrade}>
              {t('As_Settings_NavUpgrade')}
            </button>
          </div>
        )}
      </div>
    </dialog>
  );
}
function TTSOriginalPop({ ttsTextId, onTTS, ttsSentenceNum, onTTSAll, isTTSAll }) {
  const { t } = useTranslation();
  const { ttsOriginalPop, setTtsOriginalPop, userDetail, setUserDetail, priceList } =
    useContext(EditContext);
  const { setIsOpen } = useDrawer();
  const PopUpRef = useRef();
  // 是否下次提醒状态
  const [showTip, setShowTip] = useState(false);
  // 消耗积分
  const [consumePoints, setConsumePoints] = useState(0);
  // 用户积分
  const [userPoints, setUserPoints] = useState(0);
  const init = async (id) => {
    // 获取用户积分
    setUserPoints(userDetail.actualTotalPoints);
    // 获取消费价格
    const untilPri = priceList.find((res) => res.mode === 'sentence_modify').number || 0;
    setConsumePoints(untilPri * ttsSentenceNum);
    if (
      untilPri * ttsSentenceNum > userDetail.actualTotalPoints ||
      !userDetail.popUpRecord.asModifySentence
    ) {
      PopUpRef.current.show();
    } else {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useUpdate(id);
    }
  };
  useEffect(() => {
    if (ttsOriginalPop) {
      init(ttsTextId);
    } else {
      PopUpRef.current.close();
    }
    setShowTip(false);
  }, [ttsTextId, ttsOriginalPop]);
  const closePop = () => {
    setTtsOriginalPop(false);
  };
  const upgrade = () => {
    setIsOpen(true);
  };
  // const handleSwitchChangeSync = (e) => {
  //   setShowTip(e.target.checked);
  // };
  const useUpdate = (id) => {
    if (showTip) {
      try {
        popupController.popUpRecord({
          body: {
            asModifySentence: showTip,
          },
        });
      } catch (error) {
        console.log(error);
      }
    }
    if (isTTSAll) {
      onTTSAll &&
        onTTSAll(() => {
          backPoints(consumePoints);
        });
    } else {
      const textid = isNumber(id) ? id : ttsTextId;
      onTTS &&
        onTTS(textid, () => {
          backPoints(consumePoints);
        });
    }
    userDetail.actualTotalPoints = userDetail.actualTotalPoints - consumePoints;
    setUserDetail(userDetail);
    closePop();
  };
  const backPoints = (num) => {
    userDetail.actualTotalPoints = userDetail.actualTotalPoints + num;
    setUserDetail(userDetail);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      <EseClosePopup close={closePop} />
      <div className="modal-box padding_model min-w-[480]">
        <div className="title">{t('As_Edit_UpdateVoicePoP334')}</div>
        <img src={close} className="close" onClick={closePop} />
        {userPoints >= consumePoints ? (
          <div className="pop_bottom">
            <div className="tip">
              {showTip ? (
                <input
                  type="checkbox"
                  className="checkbox checkbox-sm checkbox-primary"
                  checked
                  onChange={() => {
                    setShowTip(false);
                  }}
                />
              ) : (
                <input
                  type="checkbox"
                  style={{ opacity: 0.3 }}
                  className="checkbox checkbox-sm checkbox-primary"
                  checked
                  onChange={() => {
                    setShowTip(true);
                  }}
                />
              )}
              <span className="tipcon">{t('As_Edit_NotifyOption')}</span>
            </div>
            <button className="btn btn-primary btn-xs submit submit_update" onClick={useUpdate}>
              <div>
                <span>{t('As_Edit_UpdateConf')}</span>
                <div>
                  <img src={Member} />
                  {consumePoints}
                </div>
              </div>
            </button>
          </div>
        ) : (
          <div className="pop_bottom">
            <div className="tip">
              {t('As_Edit_Creditstatusnotify')}: <img src={Member} style={{ width: '18px' }} />
              {userPoints}
            </div>
            <button className="btn btn-primary btn-xs upgrade" onClick={upgrade}>
              {t('As_Settings_NavUpgrade')}
            </button>
          </div>
        )}
      </div>
    </dialog>
  );
}
function TTSTranslationPop({ ttsTextId, onTTS, ttsSentenceNum, onTTSAll, isTTSAll }) {
  const { t } = useTranslation();
  // ttsTextId：句子id， onTTS：TTS回调
  const { ttstranslationPop, setTtstranslationPop, userDetail, setUserDetail, priceList } =
    useContext(EditContext);
  const { setIsOpen } = useDrawer();
  const PopUpRef = useRef();
  // 是否下次提醒状态
  const [showTip, setShowTip] = useState(false);
  // 消耗积分
  const [consumePoints, setConsumePoints] = useState(0);
  // 用户积分
  const [userPoints, setUserPoints] = useState(0);
  const init = async (id) => {
    // 获取用户积分
    setUserPoints(userDetail.actualTotalPoints);
    // 获取消费价格
    const untilPri = priceList.find((res) => res.mode === 'sentence_modify').number || 0;
    setConsumePoints(untilPri * ttsSentenceNum);

    if (
      untilPri * ttsSentenceNum > userDetail.actualTotalPoints ||
      !userDetail.popUpRecord.asTranslateSentence
    ) {
      PopUpRef.current.show();
    } else {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useRedub(id);
    }
  };
  useEffect(() => {
    if (ttstranslationPop) {
      init(ttsTextId);
    } else {
      PopUpRef.current.close();
    }
    setShowTip(false);
  }, [ttsTextId, ttstranslationPop]);
  const closePop = () => {
    setTtstranslationPop(false);
  };
  const upgrade = () => {
    setIsOpen(true);
  };
  // const handleSwitchChangeSync = (e) => {
  //   setShowTip(e.target.checked);
  // };
  const useRedub = (id) => {
    if (showTip) {
      try {
        popupController.popUpRecord({
          body: {
            asTranslateSentence: showTip,
          },
        });
      } catch (error) {
        console.log(error);
      }
    }
    if (isTTSAll) {
      onTTSAll &&
        onTTSAll(() => {
          backPoints(consumePoints);
        });
    } else {
      const textid = isNumber(id) ? id : ttsTextId;
      onTTS &&
        onTTS(textid, () => {
          backPoints(consumePoints);
        });
    }
    userDetail.actualTotalPoints = userDetail.actualTotalPoints - consumePoints;
    setUserDetail(userDetail);
    closePop();
  };
  const backPoints = (num) => {
    userDetail.actualTotalPoints = userDetail.actualTotalPoints + num;
    setUserDetail(userDetail);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      <EseClosePopup close={closePop} />
      <div className="modal-box padding_model min-w-[480]">
        <div className="title">{t('As_Edit_UpdateTranslatedVoice334')}</div>
        <img src={close} className="close" onClick={closePop} />
        {userPoints >= consumePoints ? (
          <div className="pop_bottom">
            <div className="tip">
              {showTip ? (
                <input
                  type="checkbox"
                  className="checkbox checkbox-sm checkbox-primary"
                  checked
                  onChange={() => {
                    setShowTip(false);
                  }}
                />
              ) : (
                <input
                  type="checkbox"
                  style={{ opacity: 0.3 }}
                  className="checkbox checkbox-sm checkbox-primary"
                  checked
                  onChange={() => {
                    setShowTip(true);
                  }}
                />
              )}
              <span className="tipcon">{t('As_Edit_NotifyOption')}</span>
            </div>
            <button className="btn btn-primary btn-xs submit submit_Redub" onClick={useRedub}>
              <div>
                <span>{t('As_Edit_Update334')}</span>
                <div>
                  <img src={Member} />
                  {consumePoints}
                </div>
              </div>
            </button>
          </div>
        ) : (
          <div className="pop_bottom">
            <div className="tip">
              {t('As_Edit_Creditstatusnotify')}: <img src={Member} style={{ width: '20px' }} />
              {userPoints}
            </div>
            <button className="btn btn-primary btn-xs upgrade" onClick={upgrade}>
              {t('As_Settings_NavUpgrade')}
            </button>
          </div>
        )}
      </div>
    </dialog>
  );
}
function CreateCopyPop({ targetLanguageCode }) {
  const { t } = useTranslation();
  const {
    userDetail,
    setUserDetail,
    priceList,
    mode,
    projectDetail,
    copeProjectPop,
    setCopeProjectPop,
    editTargetLanguageList,
    sessionId,
  } = useContext(EditContext);
  const PopUpRef = useRef();
  const [needPoints, setNeedPoints] = useState(0);
  const [showTip, setShowTip] = useState(false);
  const [popLevel, setPopLevel] = useState(0);
  const [targetLanguage, setTargetLanguage] = useState('');
  const [isCope, setIsCope] = useState(false);
  useEffect(() => {
    if (copeProjectPop) {
      const need_credits = needCredits();
      const level =
        userDetail.popUpRecord.asCopyProject && userDetail.actualTotalPoints >= need_credits
          ? 1
          : 0;
      if (level === 1) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useCopy();
      }
      setPopLevel(level);
      setTargetLanguage(
        editTargetLanguageList?.find((res) => res.id === targetLanguageCode)?.language,
      );
      setShowTip(false);
      PopUpRef.current.show();
    } else {
      PopUpRef.current?.close();
    }
  }, [copeProjectPop]);
  const handleSwitchChangeSync = (e) => {
    setShowTip(e.target.checked);
  };
  const needCredits = () => {
    const time = Math.ceil(projectDetail.duration / 1000 / 60);
    const useTTS = mode === 'translation_and_tts';
    const onePrice = priceList?.find((res) =>
      useTTS ? res.mode === 'translation_and_tts' : res.mode === 'translation',
    )?.number;
    const need_credits = onePrice * time;
    setNeedPoints(need_credits);
    return need_credits;
  };
  const closePop = () => {
    setCopeProjectPop(false);
  };
  const useCopy = async () => {
    if (isCope) return;
    setIsCope(true);
    try {
      // 创建副本函数
      const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
      await projectController.copyProject({
        projectId: projectItem.id,
        body: {
          sessionId,
          languageCode: targetLanguageCode,
        },
      });
      if (showTip) {
        popupController.popUpRecord({
          body: {
            asCopyProject: true,
          },
        });
        userDetail.popUpRecord.asCopyProject = true;
      }
      userDetail.actualTotalPoints = userDetail.actualTotalPoints - needPoints;
      setUserDetail(userDetail);
      setPopLevel(1);
    } catch (e) {
      message.error(JSON.parse(e).msg);
    }
    setIsCope(false);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      <EseClosePopup close={closePop} />
      {popLevel === 0 ? (
        <div className="modal-box padding_model min-w-[480]">
          <div className="title">{t('As_Edit_CreateNewTrans')}</div>
          <img src={close} alt="" className="close" onClick={closePop} />
          {userDetail.actualTotalPoints >= needPoints ? (
            <div className="pop_bottom">
              <div className="tip">
                <input
                  type="checkbox"
                  className="checkbox checkbox-sm checkbox-primary"
                  checked={showTip}
                  onChange={handleSwitchChangeSync}
                />
                <span className="tipcon">{t('As_Edit_NotifyOption')}</span>
              </div>
              <button
                className="btn btn-primary btn-xs submit submit_update"
                onClick={useCopy}
                style={{ opacity: isCope ? 0.4 : 1 }}>
                <div>
                  <span>{t('As_Edit_CreateNewTransButton')}</span>
                  <div>
                    <img src={Credits} />
                    {parseFloat(needPoints.toFixed(1))}
                  </div>
                </div>
              </button>
            </div>
          ) : (
            <div className="pop_bottom">
              <div className="tip">
                {t('As_Edit_Creditstatusnotify')}: <img src={Credits} />
                {userDetail.actualTotalPoints}
              </div>
              <button className="btn btn-primary btn-xs upgrade" onClick={() => setIsOpen(true)}>
                {t('As_Settings_NavUpgrade')}
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="modal-box padding_model min-w-[480]">
          <div className="title">{t('As_Edit_NewTransCreated')}</div>
          <img src={close} className="close" onClick={closePop} />
          <div className="copeTip">
            {t('As_Edit_NewTransCreatedDesc', {
              language: targetLanguage,
            })}{' '}
            {t('As_Edit_NewTransCreatedDesc2')}{' '}
            <u onClick={() => window.open(`${window.location.origin}/home`, '_blank')}>
              {t('As_Edit_NewTransCreatedDesc3')}
            </u>
          </div>
          <div className="pop_bottom pop_copy">
            <div className="tip" />
            <button className="btn btn-primary btn-xs submit submit_update" onClick={closePop}>
              {t('As_Edit_GotIt')}
            </button>
          </div>
        </div>
      )}
    </dialog>
  );
}
function SentenceTranslation({
  sentenceNum,
  onSentenceTranslate,
  handleUpdateAll,
  translationType,
}) {
  const { t } = useTranslation();
  const {
    sentenceTranslationPopup,
    setSentenceTranslationPopup,
    priceList,
    userDetail,
    setUserDetail,
  } = useContext(EditContext);
  const { setIsOpen } = useDrawer();
  const [showTip, setShowTip] = useState(false);
  // 消耗积分
  const [consumePoints, setConsumePoints] = useState(0);
  // 用户积分
  const [userPoints, setUserPoints] = useState(0);
  const PopUpRef = useRef();
  const init = async () => {
    setUserPoints(userDetail.actualTotalPoints);
    const untilPri = priceList.find((res) => res.mode === 'sentence_translation').number || 0;
    setConsumePoints(Number((untilPri * sentenceNum).toFixed(1)));
    if (
      userDetail.actualTotalPoints < Number((untilPri * sentenceNum).toFixed(1)) ||
      !userDetail.popUpRecord.asTranslateAgain
    ) {
      PopUpRef.current?.show();
    } else {
      handleTranslate();
    }
  };
  useEffect(() => {
    if (sentenceTranslationPopup) {
      init();
    } else {
      PopUpRef.current?.close();
    }
    setShowTip(false);
  }, [sentenceTranslationPopup]);
  const closePop = () => {
    setSentenceTranslationPopup(false);
  };
  const upgrade = () => {
    setIsOpen(true);
  };
  const handleTranslate = () => {
    if (showTip) {
      popupController.popUpRecord({
        body: {
          asTranslateAgain: true,
        },
      });
      userDetail.popUpRecord.asTranslateAgain = true;
    }
    if (translationType === 'all') {
      handleUpdateAll &&
        handleUpdateAll(() => {
          backPoints(consumePoints);
        });
    } else {
      onSentenceTranslate &&
        onSentenceTranslate(() => {
          backPoints(consumePoints);
        });
    }
    userDetail.actualTotalPoints = userDetail.actualTotalPoints - consumePoints;
    setUserDetail(userDetail);
    closePop();
  };
  const backPoints = (num) => {
    userDetail.actualTotalPoints = userDetail.actualTotalPoints + num;
    setUserDetail(userDetail);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      <EseClosePopup close={closePop} />
      <div className="modal-box padding_model min-w-[480]">
        <div className="title translate_title">{t('As_Edit_UpdateSubtitle334')}</div>
        <img src={close} className="close" onClick={closePop} />
        {userPoints >= consumePoints ? (
          <div className="pop_bottom">
            <div className="tip">
              {showTip ? (
                <input
                  type="checkbox"
                  className="checkbox checkbox-sm checkbox-primary"
                  checked
                  onChange={() => {
                    setShowTip(false);
                  }}
                />
              ) : (
                <input
                  type="checkbox"
                  style={{ opacity: 0.3 }}
                  className="checkbox checkbox-sm checkbox-primary"
                  checked
                  onChange={() => {
                    setShowTip(true);
                  }}
                />
              )}
              <span className="tipcon">{t('As_Edit_NotifyOption')}</span>
            </div>
            <button className="btn btn-primary btn-xs submit" onClick={handleTranslate}>
              <div>
                <span>{t('As_Edit_Speechtranslation')}</span>
                <div className="pointsNum">
                  <img src={Member} style={{ width: '20px' }} />
                  {consumePoints}
                </div>
              </div>
            </button>
          </div>
        ) : (
          <div className="pop_bottom">
            <div className="tip">
              {t('As_Edit_Creditstatusnotify')}: <img src={Member} style={{ width: '20px' }} />
              {userPoints}
            </div>
            <button className="btn btn-primary btn-xs upgrade" onClick={upgrade}>
              {t('As_Settings_NavUpgrade')}
            </button>
          </div>
        )}
      </div>
    </dialog>
  );
}
